import angular from 'angular';
import MenuItemComponent from './item.component';

const menuItemModule = angular.module('tinaba.components.menu.item', [])

.component('menuItem', MenuItemComponent);

export default menuItemModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/item/item.js
 **/